import React from 'react';
import HeaderForm from './form';
import {notification} from 'antd';
import history from '../../modules/History';
import {addBreadCrumbsItem} from '../../modules/Api';

class AddBreadCrumbs extends React.Component {
    constructor() {
        super();
        var end = new Date();
        end.setHours(23,59,58);
        this.state = {
            data: {
                expiration_date: end
            },
            submitted: false,
            
        }

    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = values;
        addBreadCrumbsItem(formData, (res) => {
            this.setState({submitted:false});
            ///check res is undefined 
            if(res.errors ) {

                notification.open({
                    message: 'خطایی رخ داده است.',
                    description: 'مقدار اولویت نباید از قبل مورد استفاده قرار گرفته باشد'
                });
    
            }
            else if(res.status && res.status==200) {
                notification.open({
                    message: `برید کرامبز با موفقیت اضافه شد!`,
                    description: ``
                });
                history.item.push(`/bread-crumbs`);
            }
            else{
                notification.open({
                    message: 'خطایی رخ داده است.',
                    description: res.message
                });
            }
        });
    }
    render() {
        return (<div><HeaderForm initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default AddBreadCrumbs;


// WEBPACK FOOTER //
// ./src/containers/BreadCrumbs/add.js